//noinspection JSFileReferences
import index from './categories/index.js';

index.init();